import React, { useEffect, useState } from 'react'
import injectStyles from 'react-jss'
import { makeStyles } from '@material-ui/core'
import classname from 'classnames'
import Button from '@material-ui/core/Button'
import { useHistory } from 'react-router-dom'

import { styles } from '../../styles'
import { PATHS } from '../../../../Config/Routing/paths'
import StyledBreadcrumbs from '../../../../Components/StyledBreadcrumbs'
import { PageTitle } from '../../../../Components/PageTitle'
import ArrowBackIcon from '../../icons/ArrowBackIcon'
import BreadcrumbsSettingsIcon from '../../../../Assets/Images/icons/breadcrumbsSettings'
import LoadingIndicator from '../../../../Components/LoadingIndicator/LoadingIndicator'
import IntegrationsService from '../../../../Module/IntegrationsService/client'
import classNames from 'classnames'

const useStyles = makeStyles(() => ({
  card: {
    boxShadow: '0px 2px 14px 0px rgba(39, 55, 84, 0.08)',
    borderRadius: '8px',
    background: '#FFFFFF',
    padding: '16px',
    width: '192px',
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '26px',
  },
  cardDescription: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    marginBottom: '16px',
  },

  button: {
    minWidth: '100% !important',
  },
}))

const SelectStore = ({ classes: sharedClasses, url }) => {
  const history = useHistory()
  const classes = useStyles()
  const [isLoading, setIsLoading] = useState(false)
  const [stores, setStores] = useState([])

  const getCards = async () => {
    const integrations = await IntegrationsService.readIntegrations()
    return integrations.map((integration, index) => {
      return {
        id: integration.id,
        title: `${integration.credentials.storeId} (${
          integration.status == 10 ? 'ACTIVE' : 'INACTIVE'
        })`, // INTEGRATIONS_TODO: add proper name field
        description: `Store ID #${index + 1}`,
        onClick:
          integration.status == 10
            ? () => {
                const urlSearchParams = new URLSearchParams(
                  history.location.search,
                )
                const redirectURL = urlSearchParams.get('redirectURL')
                const newUrl = `${url}${PATHS.clientSettings.coupons}${
                  PATHS.clientSettings.createCoupon
                }${PATHS.clientSettings.stores}/${integration.id}${
                  redirectURL ? `?redirectURL=${redirectURL}` : ''
                }`
                history.push(newUrl)
              }
            : null,
      }
    })
  }

  const fetchCards = async () => {
    setIsLoading(true)
    const cards = await getCards()

    setStores(cards)
    setIsLoading(false)
  }

  useEffect(() => {
    fetchCards()
  }, [])

  const onBack = () => {
    history.push(`${url}${PATHS.clientSettings.coupons}`)
  }

  return (
    <div className={sharedClasses.container}>
      <StyledBreadcrumbs
        icon={<BreadcrumbsSettingsIcon />}
        breadcrumbs={[
          {
            link: `${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}`,
            label: 'Settings',
          },
          {
            link: `${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}${
              PATHS.clientSettings.coupons
            }`,
            label: 'Coupons',
          },
          {
            link: `${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}${
              PATHS.clientSettings.coupons
            }${PATHS.clientSettings.createCoupon}`,
            label: 'Create Coupon',
          },
          {
            label: 'Select Store',
          },
        ]}
      />
      <PageTitle className={sharedClasses.title}>
        <div className={sharedClasses.back} onClick={onBack}>
          <ArrowBackIcon />
        </div>
        <div>Select Store</div>
      </PageTitle>
      <div className={sharedClasses.description}>
        Select the store you would like to create coupons for.
      </div>
      {isLoading ? (
        <LoadingIndicator style={{ height: '42vh' }} />
      ) : (
        <div className={classNames(sharedClasses.cardWrapper, 'cardWrapper')}>
          {stores.map(card => (
            <div className={classes.card} key={card.id} cypress_id="storeCard">
              <div className={classes.cardTitle}>{card.title}</div>
              <div className={classes.cardDescription}>{card.description}</div>
              <Button
                variant="outlined"
                onClick={card.onClick}
                disabled={!card.onClick}
                className={classname(sharedClasses.button, classes.button)}
              >
                Target
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default injectStyles(styles)(SelectStore)
